const endPointsAuth = {
    cookie: "cookie",
    none:"none"
}
export default endPointsAuth